var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('greeting_chat_buttons_message_help_view').toString())}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('default_messages_help_view').toString())}})])}
var staticRenderFns = []

export { render, staticRenderFns }